export default {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	methods: {
		downloadCsvFile(content: any, filename: any) {
			if (!content.match(/^data:text\/csv/i)) {
				content = 'data:text/csv;charset=utf-8,' + content;
			}
				
			const data = encodeURI(content);
			const link = document.createElement('a');
				
			link.setAttribute('href', data);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
	}
};